<div #magnifier class="magnifier" id="magnifier">
  <div class="magnifier-content"></div>
  <div class="magnifier-glass"></div>
  <div class="border"></div>
  <div class="button-container top-0">
    <div class="button left">
      <ibex-icon name="arrows-full-out" variant="blank"></ibex-icon>
    </div>
  </div>
  <div class="button-container bottom-0">
    <div class="button left">
      <ibex-icon (click)="zoom()" name="plus" variant="contrast"></ibex-icon>
      <ibex-icon (click)="zoom('out')" name="minus" variant="contrast"></ibex-icon>
    </div>
    <div (click)="close($event)" class="button right">
      <ibex-icon name="close" variant="contrast"></ibex-icon>
    </div>
  </div>
</div>
